import { DOCUMENT, Injectable, inject } from '@angular/core';

export interface EscapeClosable {
  closeByEscape: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class EscapeHandler {
  private document = inject(DOCUMENT);

  private windows: EscapeClosable[] = [];

  private closeHandler = (event: any) => this.closeByEscape(event);

  constructor() {
    this.document.addEventListener('keydown', this.closeHandler);
  }

  register(closable: EscapeClosable) {
    this.windows.push(closable);
  }

  unregister(closable: EscapeClosable) {
    const index = this.windows.findIndex((it) => it === closable);
    if (index > -1) {
      this.windows.splice(index, 1);
    }
  }

  private closeByEscape(event: KeyboardEvent) {
    if (this.windows.length > 0) {
      const isEscape = event.key === 'Escape';
      if (isEscape) {
        const window = this.windows[this.windows.length - 1];
        window.closeByEscape();
      }
    }
  }
}
